// for performance and prediction summaries

export enum CalibrateMode {
  Unavailable = 'Unavailable',
  ContactSupport = 'ContactSupport',
  Calibrate = 'Calibrate',
}
